import { useTranslation } from "react-i18next";

export default function MerkenBeslag() {
  const { t } = useTranslation("kozijn-reparatie");
  const items = t("merkenBeslag.items", { returnObjects: true }) as Array<{
    title: string;
    desc: string;
  }>;

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-6 md:mb-8">
          {t("merkenBeslag.h2")}
        </h2>
        <p className="font-geist text-base md:text-lg text-brand-text/70 leading-relaxed text-center mb-10 md:mb-14 max-w-[700px] mx-auto">
          {t("merkenBeslag.intro")}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-white border border-brand-border rounded-xl p-6 md:p-7 hover:border-brand-yellow transition-colors"
            >
              <div className="w-10 h-10 rounded-full bg-brand-yellow flex items-center justify-center mb-4 md:mb-5">
                <i className="ri-shield-check-line text-brand-text text-lg w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="font-geist font-bold text-lg md:text-xl text-brand-text mb-1.5 md:mb-2">
                {item.title}
              </h3>
              <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}